// extracted by mini-css-extract-plugin
export default {"noData":"NoData_noData__iGvrG","iconNoData":"NoData_iconNoData__VcEQx","noactivity":"NoData_noactivity__QSqgX"};